import {UI} from "../../../../stem-core/ui/UIBase";
import {Money} from "../../../../stem-core/localization/Money.js";
import {Payment} from "../../../../client/state/PaymentStore.js";
import {EndpointPaginator} from "../../../../stem-core/state/pagination/EndpointPaginator";
import {SimpleTable} from "../../../../dashboard/ui/SimpleTable.jsx";
import {Card} from "../../ui/Card.jsx";
import type {AdminUser} from "../../../../client/state/AdminUserStore.js";


interface UserPaymentListOptions {
    user?: AdminUser;
}

export class UserPaymentList extends UI.Element<UserPaymentListOptions> {
    render() {
        const {user} = this.options;

        const paginator = new EndpointPaginator(Payment, "/admin/payments/get_payments/", {
            userIds: [user.id],
        });

        const columns = [
            ["Id", (payment: Payment) => payment.id],
            ["Merchant", (payment: Payment) => payment.getMerchant()],
            ["Type", (payment: Payment) => payment.getType()],
            ["Amount", (payment: Payment) => Money.format(payment)],
            ["Currency", (payment: Payment) => payment.getCurrency()],
            ["Date", (payment: Payment) => payment.createdAt],
        ]

        return (
            <Card title={"Payments"}>
                <SimpleTable paginator={paginator} columns={columns} />
            </Card>
        )
    }
}
